<template>
  <div class="px-[8px] space-y-[10px]">
    <div class="h-[40px] w-full bg-gray-200 rounded animate-pulse"></div>
    <div v-for="n in itemCount" :key="n" class="pl-[24px]">
      <div class="h-[40px] w-full bg-gray-200 rounded animate-pulse"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingMenuTree",
  props: {
    itemCount: {
      type: Number,
      default: 4,
    },
  },
};
</script>

<style scoped></style>
